import React from "react";

const Loader = () => {
  return (
    <>
      <div className="content">
        Loading
      </div>
    </>
  );
};

export default Loader;
